export const ACTION_ON_ORIGIN_SELECTED = '@rails/ACTION_ON_ORIGIN_SELECTED';
export const ACTION_ON_DESTINATION_SELECTED = '@rails/ACTION_ON_DESTINATION_SELECTED';
export const ACTION_SWAP_SEARCH = '@rails/ACTION_SWAP_SEARCH';
export const ACTION_AC_BUTTON_TOGGLE = '@rails/ACTION_AC_BUTTON_TOGGLE';
export const ACTION_DATE_SELECTED = '@rails/ACTION_DATE_SELECTED';
export const ACTION_APP_STATE_CHANGE = '@rails/ACTION_APP_STATE_CHANGE';
export const ACTION_SET_RAILS_OFFERS = '@rails/ACTION_SET_RAILS_OFFERS';
export const ACTION_UPDATE_RAILS_FUNNEL_VARIANT = '@rails/ACTION_UPDATE_RAILS_FUNNEL_VARIANT';
export const ACTION_ON_ADD_RECENT_SEARCHES = '@rails/ACTION_ON_ADD_RECENT_SEARCHES';
export const ACTION_ADD_USER_DATA = '@rails/ACTION_ADD_USER_DATA';
export const ACTION_FILL_USER_DATA = '@rails/ACTION_FILL_USER_DATA';
export const ACTION_MMT_HIGHLIGHTS =  '@rails/ACTION_MMT_HIGHLIGHTS';
export const ACTION_UPDATE_FREE_CANCELLATION_OPTION = '@rails/ACTION_UPDATE_FREE_CANCELLATION_OPTION'
export const ACTION_NEW_ACCOUNT_OFFICE_BUTTON_TOGGLE = '@rails/ACTION_NEW_ACCOUNT_OFFICE_BUTTON_TOGGLE';
export const ACTION_USER_ACCOUNT_VALIDATION_FAIL = '@rails/ACTION_USER_ACCOUNT_VALIDATION_FAIL';
export const ACTION_SET_PIN_CODE_DATA = '@rails/ACTION_SET_PIN_CODE_DATA';
export const ACTION_SET_TO_INIT_STATE_USER_DATA = '@rails/ACTION_SET_TO_INIT_STATE_USER_DATA';
export const ACTION_RESET_RAIL_LANDING = '@rails/ACTION_RESET_RAIL_LANDING';
export const ACTION_SET_OTHER_OFFERS = '@rails/ACTION_SET_OTHER_OFFERS'
export const ACTION_UPDATE_LANDING_DETAILS = '@rails/ACTION_UPDATE_LANDING_DETAILS';
export const ACTION_OPEN_TRAIN_PICKER = '@rails/ACTION_OPEN_TRAIN_PICKER';
export const ACTION_OPEN_STATION_PICKER = '@rails/ACTION_OPEN_STATION_PICKER';
export const ACTION_OPEN_DATE_PICKER = '@rails/ACTION_OPEN_DATE_PICKER';
export const ACTION_UPDATE_BOOKING_SOURCE = '@rails/ACTION_UPDATE_BOOKING_SOURCE';
export const ACTION_SET_LOCUS_DETAILS = '@rails/ACTION_SET_LOCUS_DETAILS';
export const ACTION_UPDATE_SELECTED_CLASS = '@rails/ACTION_UPDATE_SELECTED_CLASS';
export const ACTION_FETCH_SECTION_ORDERS_INIT = '@rails/ACTION_FETCH_SECTION_ORDERS_INIT';
export const ACTION_FETCH_SECTION_ORDERS_SUCCESS = '@rails/ACTION_FETCH_SECTION_ORDERS_SUCCESS';
export const ACTION_FETCH_SECTION_ORDERS_FAILED = '@rails/ACTION_FETCH_SECTION_ORDERS_FAILED';
export const ACTION_UPDATE_CONFIG_KEY_DATA = '@rails/ACTION_UPDATE_CONFIG_KEY_DATA';
export const ACTION_FETCH_RIS_OPTION_SUCCESS_WEB = '@rails/ACTION_FETCH_RIS_OPTION_SUCCESS_WEB';
export const ACTION_FETCH_RIS_OPTION_SUCCESS_APP = '@rails/ACTION_FETCH_RIS_OPTION_SUCCESS_APP';
export const ACTION_SET_CAPTCHA_NULL = '@rails/ACTION_SET_CAPTCHA_NULL';
export const ACTION_SET_USER_DATA_LOADER = '@rails/ACTION_SET_USER_DATA_LOADER';
export const ACTION_SET_SESSION_ID_AND_CAPTCHA = '@rails/ACTION_SET_SESSION_ID_AND_CAPTCHA';
export const ACTION_UPDATE_LTS_DATE = '@rails/ACTION_UPDATE_LTS_DATE';
export const ACTION_UPDATE_LTS_BOARDING_DATA = '@rails/ACTION_UPDATE_LTS_BOARDING_DATA';
export const ACTION_UPDATE_START_DATE_OPTION = '@rails/ACTION_UPDATE_START_DATE_OPTION';
export const ACTION_SET_APP_VERSION = '@rails/ACTION_SET_APP_VERSION';
export const ACTION_REDIRECT_FROM_SEO = '@rails/ACTION_REDIRECT_FROM_SEO';
export const ACTIONS_RAILS_SCHEDULE_TATAKAL_ALL_FORMS = '@rails/ACTIONS_RAILS_SCHEDULE_TATAKAL_ALL_FORMS';
export const ACTION_TATKAL_ALERT_BOTTOM_SHEET = '@rails/ACTION_TATKAL_ALERT_BOTTOM_SHEET';

